import React, { useEffect, useMemo, useReducer, useState } from "react";
import { Switch, BrowserRouter, Route, Redirect } from "react-router-dom";
import { Grid, useMediaQuery, useTheme, makeStyles } from "@material-ui/core";
import {
  Register,
  Login,
  Dashboard,
  SampleScreen,
  AssignScreen,
  RequestScreen,
  LabScreen,
  History,
  Profile,
  AboutUsScreen,
  SupportScreen,
  UnioSupport,
  LabSupport,
  Tyc,
  VerifyEmail,
} from "./screens";
import {
  AuthContext,
  QuantityContext,
  PathContext /*BadgeContext*/,
} from "./context";
import { ProtectedRoute, TabBar, Header, Drawer, PopUp } from "./components";
import { modals } from "./constants";
import AuthHandler from "./AuthHandler";
import { doctorServices } from "./services"; // Import services

const protectedRoutes = [
  {
    path: "/",
    component: Dashboard,
  },
  {
    path: "/sample",
    component: SampleScreen,
  },
  {
    path: "/assign",
    component: AssignScreen,
  },
  {
    path: "/request",
    component: RequestScreen,
  },
  {
    path: "/laboratory",
    component: LabScreen,
  },
  {
    path: "/history",
    component: History,
  },
  {
    path: "/profile",
    component: Profile,
  },
  {
    path: "/about-us",
    component: AboutUsScreen,
  },
  {
    path: "/support",
    component: SupportScreen,
  },
  {
    path: "/unio-support",
    component: UnioSupport,
  },
  {
    path: "/lab-support",
    component: LabSupport,
  },
];

export default function Routes() {
  const [modal, setModal] = useState(false);

  const [tabState, tabDispatch] = useReducer(
    (prevState, action) => {
      switch (action.type) {
        case "CHANGETAB":
          return {
            ...prevState,
            index: action.index,
          };
        default:
          return { ...prevState };
      }
    },
    {
      index: 0,
    }
  );

  const [quantityState, quantityDispatch] = useReducer(
    (prevState, action) => {
      switch (action.type) {
        case "SETQUANTITY":
          return {
            ...prevState,
            quantity: action.quantity,
          };
        default:
          return { ...prevState };
      }
    },
    {
      quantity: 0,
    }
  );

  const [authState, dispatch] = useReducer(
    (prevState, action) => {
      switch (action.type) {
        case "RESTORE_TOKEN":
          return {
            ...prevState,
            token: action.token,
            user: action.user,
            doctor: action.doctor,
            tutorial: action.tutorial,
          };
        case "LOGIN":
          return {
            ...prevState,
            token: action.token,
            user: action.user,
            doctor: action.doctor,
            tutorial: action.tutorial,
          };
        case "LOGOUT":
          return {
            ...prevState,
            token: null,
            user: null,
            doctor: null,
          };
        case "EDIT":
          return {
            ...prevState,
            user: action.user,
          };
        default:
          return { ...prevState };
      }
    },
    {
      token: null,
      user: null,
      doctor: null,
      tutorial: 0,
    }
  );

  // const [badgeState, badgeDispatch] = useReducer(
  //   (prevState, action) => {
  //     switch (action.type) {
  //       case "SHOW":
  //         return {
  //           ...prevState,
  //           show: true,
  //         };
  //       case "HIDE":
  //         return {
  //           ...prevState,
  //           show: false,
  //         };
  //       default : return { ...prevState };
  //     }
  //   },
  //   {
  //     show: false,
  //   }

  // )

  useEffect(() => {
    try {
      // Función para obtener cookie por nombre
      const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      };

      let token = getCookie("unio_token");

      // Fallback para desarrollo local (localhost) u otros métodos de redirección.
      // Se excluye /verify-email porque su ?token es de verificación de correo, no de sesión.
      const isVerifyEmailPage = window.location.pathname === '/verify-email';
      if (!token && !isVerifyEmailPage) {
        const urlParams = new URLSearchParams(window.location.search);
        token = urlParams.get("token");
        if (!token && window.location.hash.includes("token=")) {
          token = window.location.hash.split("token=")[1].split("&")[0];
        }
      }

      if (token && !isVerifyEmailPage) {
        // Token encontrado desde la cookie compartida o URL
        localStorage.setItem("token", token);
        // Opcional: limpiar la cookie para que no quede colgando
        document.cookie = "unio_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.unio.cl; path=/;";

        // Limpiar URL si vino por URL (opcional para mantenerla limpia)
        if (window.history.replaceState) {
          const cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
          window.history.replaceState({ path: cleanUrl }, '', cleanUrl);
        }
      } else {
        token = localStorage.getItem("token");
      }

      const user = JSON.parse(localStorage.getItem("user"));
      const doctor = localStorage.getItem("doctor");
      let tutorial = localStorage.getItem("tutorial");
      if (tutorial) {
        tutorial = parseInt(tutorial);
      } else {
        tutorial = 1;
        localStorage.setItem("tutorial", tutorial);
      }
      dispatch({
        type: "RESTORE_TOKEN",
        token,
        user,
        doctor: doctor !== "undefined" ? JSON.parse(doctor) : null,
        tutorial,
      });
    } catch (error) {
      console.error("[Auth] Error restaurando sesión desde localStorage:", error);
      ["token", "refreshToken", "user", "doctor", "userRut", "tutorial"].forEach((key) =>
        localStorage.removeItem(key)
      );
      window.location.href = "/iniciar-sesion";
    }
  }, []);

  useEffect(() => {
    if (!("Notification" in window)) {
      return;
    } else if (Notification.permission === "granted") {
      console.log("granted");
    }
    // Si no, tendremos que pedir permiso al usuario!!
    else if (Notification.permission !== "denied") {
      Notification.requestPermission().then(function (permission) {
        console.log(permission);
      });
    }
  }, []);

  // useEffect(() => {
  //   if (!("Notification" in window)) {
  //     return ;
  //   }
  //   else if(Notification.permission==="granted" && authState.user){
  //     authState.user.doctor.specialties.forEach((especialty) => {
  //       socket.on(`${especialty.name}`, (socket) => {
  //         console.log('se agrego este producto', socket)
  //         badgeDispatch({ type:"SHOW" });
  //            /*alert(`Se agrego el siguiente producto ${socket.product.name}`)
  //             */
  //            new Notification(`Se agrego el siguiente producto:`,{
  //             body:`${socket.product.name}`
  //            })
  //         /*navigator.serviceWorker.register('./sw.js');
  //         navigator.serviceWorker.ready.then(function(registration) {
  //           registration.showNotification('Se agrego el siguiente producto: ', {
  //             body:`${socket.product.name}`
  //           });
  //         })*/
  //       })
  //     })
  //   }
  // }, [authState.user])

  //   useEffect(()=>{
  //   if (Notification.permission === "granted") {
  //     // Si esta correcto lanzamos la notificación
  //     navigator.serviceWorker.ready.then(function(registration) {
  //       registration.showNotification('Holiwis :D')
  //     })
  //     //new Notification("Holiwis :D");
  //     console.log("granted")
  //   }
  //   // Si no, tendremos que pedir permiso al usuario
  //   else if (Notification.permission !== 'denied') {
  //     console.log("denied")
  //     Notification.requestPermission().then(function (permission) {
  //       // Si el usuario acepta, lanzamos la notificación
  //       console.log({permission})
  //       if (permission === "granted") {
  //         navigator.serviceWorker.register('sw.js');
  //         navigator.serviceWorker.ready.then(function(registration) {
  //           registration.showNotification('Gracias majo!')
  //         })
  //         //new Notification("Gracias majo!");
  //       }
  //     })
  //   }
  // },[]);

  // useEffect(() => {
  //   if(Notification.permission==="granted" && authState.user){
  //     authState.user.doctor.specialties.forEach((especialty) => {
  //       socket.on(`${especialty.name}`, (socket) => {
  //         console.log('se agrego este producto', socket)
  //            /*alert(`Se agrego el siguiente producto ${socket.product.name}`)
  //             new Notification(`Se agrego el siguiente producto:`,{
  //             body:`${socket.product.name}`
  //            })*/
  //         navigator.serviceWorker.register('sw.js');
  //         navigator.serviceWorker.ready.then(function(registration) {
  //           registration.showNotification('Se agrego el siguiente producto: 2', {
  //             body:`${socket.product.name}`
  //           })
  //         })
  //       })
  //     })
  //   }
  // }, [authState.user])

  const authContext = useMemo(
    () => ({
      authState,
      signIn: async ({ token, user, doctor }) => {
        // token passed here is the accessToken
        localStorage.setItem("token", token);

        // Handle refreshToken if present in user object (nested) or if passed separately (though signature implies token, user, doctor)
        // In login.jsx we will pass the structure.
        // If user object contains refreshToken, save it.
        if (user?.refreshToken) {
          localStorage.setItem("refreshToken", user.refreshToken);
        }

        localStorage.setItem("user", JSON.stringify(user));
        // Safe check for doctor presence
        if (doctor && doctor.rut) {
          localStorage.setItem("userRut", doctor.rut);
        }
        localStorage.setItem("doctor", JSON.stringify(doctor));
        let tutorial = localStorage.getItem("tutorial");
        /*  setModal(true)  */

        //primera vez
        if (!tutorial) {
          tutorial = 1;
          localStorage.setItem("tutorial", tutorial);
        }
        //segunda vez
        else if (tutorial) {
          tutorial = parseInt(tutorial);
          if (tutorial === 1) {
            tutorial = 2;
            localStorage.setItem("tutorial", tutorial);
          } else if (tutorial === 2) {
            tutorial = 3;
            localStorage.setItem("tutorial", tutorial);
          } else {
            tutorial = 4;
          }
        }

        //console.log('user token: ', token);
        await dispatch({ type: "LOGIN", token, user, doctor, tutorial });
      },
      signOut: async () => {
        try {
          const refreshToken = localStorage.getItem("refreshToken");
          if (refreshToken) {
            await doctorServices.logout({ refreshToken });
          }
        } catch (e) {
          console.error("Error logging out", e);
        } finally {
          localStorage.removeItem("token");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("user");
          localStorage.removeItem("doctor");
          await dispatch({ type: "LOGOUT" });
        }
      },
      editProfile: async ({ user }) => {
        console.log("user", user);
        await dispatch({ type: "EDIT", user: user });
      },
    }),
    [authState]
  );

  const quantityContext = {
    quantityState,
    setQuantity: async ({ quantity }) => {
      quantityDispatch({ type: "SETQUANTITY", quantity });
    },
  };

  const pathContext = {
    tabState,
    setTab: ({ index }) => {
      tabDispatch({ type: "CHANGETAB", index });
    },
  };

  // const badgeContext = {
  //   badgeState,
  //   show:() => {
  //     badgeDispatch({ type:"SHOW" } );
  //   },
  //   hide:() => {
  //     badgeDispatch({ type:"HIDE" } );
  //   }
  // }

  const matches = useMediaQuery(useTheme().breakpoints.up("md"));
  const classes = useStyles();

  return (
    <AuthContext.Provider value={authContext}>
      <BrowserRouter>
        <QuantityContext.Provider value={quantityContext}>
          <PathContext.Provider value={pathContext}>
            {authState.user && authState.tutorial <= 3 && (
              <PopUp
                modalName={modals[9]}
                open={modal}
                setModal={() => setModal(!modal)}
              />
            )}
            {!matches && authState.token && <Header />}
            {
              <Grid container className={classes.routesContainer}>
                {authState.token && <Drawer />}
                <Switch>
                  <Route path="/auth" component={AuthHandler} />
                  {protectedRoutes.map((option, index) => (
                    <ProtectedRoute
                      key={index}
                      exact
                      path={option.path}
                      token={authState.token}
                      auth={true}
                      component={() => <option.component />}
                    />
                  ))}
                  <ProtectedRoute
                    exact
                    path="/iniciar-sesion"
                    auth={false}
                    token={authState.token}
                    component={Login}
                  />
                  <ProtectedRoute
                    exact
                    path="/registro"
                    auth={false}
                    token={authState.token}
                    component={Register}
                  />
                  <ProtectedRoute
                    exact
                    path="/tyc"
                    auth={false}
                    component={Tyc}
                  />
                  <ProtectedRoute
                    exact
                    path="/verify-email"
                    auth={false}
                    token={authState.token}
                    component={VerifyEmail}
                  />
                  <Route component={() => <Redirect to="/" />}></Route>
                </Switch>
              </Grid>
            }
            {/* <BadgeContext.Provider value={badgeContext}> */}
            {!matches && authState.token && <TabBar onClick={() => { }} />}
            {/* </BadgeContext.Provider> */}
          </PathContext.Provider>
        </QuantityContext.Provider>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

const useStyles = makeStyles((theme) => ({
  routesContainer: {
    "& > div:nth-child(1)": {
      flex: 1,
      height: "calc(100vh - 135px)",
      '@supports (height: 100dvh)': {
        height: 'calc(100dvh - 135px)',
      },
      [theme.breakpoints.up("md")]: {
        flex: "unset",
        height: "unset",
      },
    },
    [theme.breakpoints.up("md")]: {
      "& > div:nth-child(2)": {
        flex: 1,
        height: "100vh",
        '@supports (height: 100dvh)': {
          height: '100dvh',
        },
      },
    },
  },
}));
